// utils/companyManager.ts - localStorage kontrolü eklendi
import { requiresCompanySelection, hasCarbonAccountingRole, hasSupplyChainRole } from "./userRoleHelper";
import { getCarbonAccountingCompanyId } from './applicationHelper';
import type { User } from '@/types';


export const handleCompanySelection = (
  userData: User,
  showCompanySelectionModal: () => void
): string | null => {
  if (!userData || !userData.roles) {
    console.error('Invalid user data');
    return null;
  }

  const { roles, organization } = userData;
  const applications = organization?.applications || [];


  if (hasCarbonAccountingRole(roles)) {
    const companyId = getCarbonAccountingCompanyId(applications);

    if (companyId) {
      console.log('Carbon Accounting Company ID set:', companyId);
      return companyId;
    } else {
      console.warn('Carbon Accounting role found but no active application');
      return null;
    }
  }


  if (requiresCompanySelection(roles)) {

    const storedCompanyId = localStorage.getItem("companyId");

    if (storedCompanyId) {
      console.log('Company ID found in localStorage:', storedCompanyId);
      return storedCompanyId;
    }

    console.log('Company selection required for user roles - no stored companyId');
    showCompanySelectionModal();
    return null;
  }

  const encodeToken = (token: string) => {
    return btoa(token);
  };
  //@ts-ignore
  const queryString = `idToken=${encodeURIComponent(localStorage.getItem('idToken'))}&accessToken=${encodeURIComponent(localStorage.getItem('token'))}&refreshToken=${encodeURIComponent(localStorage.getItem('refreshToken'))}`;
  const params = `/login?auth-callback=${encodeToken(queryString)}`

  if (hasSupplyChainRole(roles)) {
    if (import.meta.env.DEV) {
      window.location.href = `http://localhost:5174${params}`
    } else {
      window.location.href = `https://supply-chain.${import.meta.env.VITE_APP_MODE}bono.eco${params}`
    }
    return null;
  }

  console.log('Roles', roles);

  // Hiçbir özel durum yoksa
  console.log('No special company handling required');
  return null;
};

/**
 * Alternatif: Daha kapsamlı localStorage kontrolü
 */
export const handleCompanySelectionAdvanced = (
  userData: User,
  showCompanySelectionModal: () => void
): string | null => {
  if (!userData || !userData.roles) {
    console.error('Invalid user data');
    return null;
  }

  const { roles, organization } = userData;
  const applications = organization?.applications || [];
  const storedCompanyId = localStorage.getItem("companyId");

  // Carbon Accounting rolü kontrolü
  if (hasCarbonAccountingRole(roles)) {
    const companyId = getCarbonAccountingCompanyId(applications);

    if (companyId) {
      console.log('Carbon Accounting Company ID set:', companyId);

      // localStorage'u güncelle
      if (storedCompanyId !== companyId) {
        localStorage.setItem("companyId", companyId);
      }

      return companyId;
    } else {
      console.warn('Carbon Accounting role found but no active application');

      // Eğer localStorage'da companyId varsa onu kullan
      if (storedCompanyId) {
        console.log('Using stored companyId as fallback:', storedCompanyId);
        return storedCompanyId;
      }

      return null;
    }
  }

  // Şirket seçimi gerektiren roller kontrolü
  if (requiresCompanySelection(roles)) {
    console.log("Roles", roles);

    // localStorage'da companyId var mı kontrol et
    if (storedCompanyId) {
      console.log('Company ID found in localStorage:', storedCompanyId);
      return storedCompanyId;
    }

    console.log('Company selection required for user roles - no stored companyId');
    showCompanySelectionModal();
    return null;
  }

  // Diğer roller için localStorage kontrolü
  if (storedCompanyId) {
    console.log('Using stored companyId for other roles:', storedCompanyId);
    return storedCompanyId;
  }

  // Hiçbir özel durum yoksa
  console.log('No special company handling required');
  return null;
};